import { Search } from "lucide-react";
import React from "react";

import { IgAutocomplete } from "@intelligems/ig-theme/IgAutocomplete";
import { IgCheckbox } from "@intelligems/ig-theme/IgCheckbox";
import { IgTextField } from "@intelligems/ig-theme/IgTextField";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";

interface ProductTargetingAutofillValueProps {
  selectedValues: { label: string; value: string }[];
  options: { label: string; value: string }[];
  onChange: (values: { label: string; value: string }[]) => void;
  placeholder: string;
  singleSelect?: boolean;
}

export const ProductTargetingAutofillValue = ({
  selectedValues,
  options,
  onChange,
  placeholder,
  singleSelect = false,
}: ProductTargetingAutofillValueProps) => {
  if (singleSelect) {
    return (
      <IgAutocomplete
        sx={{ maxWidth: "500px" }}
        slotProps={{
          listbox: {
            sx: {
              maxHeight: "200px",
            },
          },
        }}
        value={selectedValues[0] ?? null}
        options={options}
        onChange={(_, newValue) => {
          onChange(newValue ? [newValue] : []);
        }}
        isOptionEqualToValue={(option, value) => value.value === option.value}
        getOptionLabel={(option) => `${option.label}`}
        renderInput={(params) => (
          <IgTextField {...params} placeholder={placeholder} />
        )}
        fullWidth={true}
      />
    );
  }

  return (
    <IgAutocomplete
      multiple
      sx={{ maxWidth: "500px" }}
      slotProps={{
        listbox: {
          sx: {
            maxHeight: "200px",
          },
        },
      }}
      disableCloseOnSelect
      value={selectedValues}
      renderValue={() => null}
      options={options}
      onChange={(_, newValue) => {
        onChange(newValue);
      }}
      isOptionEqualToValue={(
        option,
        value: { value: string; label: string }
      ) => {
        return value.value === option.value;
      }}
      getOptionLabel={(option) => {
        return `${option.label}`;
      }}
      renderInput={(params) => (
        <IgTextField
          {...params}
          placeholder={placeholder}
          slotProps={{
            input: {
              ...params.InputProps,
              startAdornment: <Search size={16} style={{ marginLeft: 4 }} />,
            },
          }}
        />
      )}
      disablePortal={true}
      disableClearable={true}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <MenuItem
            key={`${key}-${props.id}`}
            {...optionProps}
            sx={{ height: "32px" }}
          >
            <Grid
              container
              direction={"row"}
              columnSpacing={1}
              alignItems={"center"}
            >
              <Grid>
                <IgCheckbox size={"small"} checked={selected} />
              </Grid>
              <Grid>
                <IgTypography>{option.label}</IgTypography>
              </Grid>
            </Grid>
          </MenuItem>
        );
      }}
      fullWidth={true}
    />
  );
};
